<template>

  <div
    class   = "preview_container"
  >
    
    <!-- Header -->
    <LayoutPane
      v-show  = "layout.header.visible"
      class   = "header"
      name    = "Header"
    >
    </LayoutPane>

    <!-- File Toolbar -->
    <FileToolbarLayoutPane
      v-show  = "layout.fileToolbar.visible"
      class   = "file_toolbar"
      :layout = "layout"
    >
    </FileToolbarLayoutPane>

    <div class="main_content">

      <!-- Left Column -->
      <div 
        v-show    = "layout.videoPlayer.visible || layout.timeline.visible"
        class     = "left column"
      >

        <!-- Video Player -->
        <LayoutPane
          v-show  = "layout.videoPlayer.visible"
          class   = "video_player"
          name    = "Video Player"
        >
        </LayoutPane>

        <!-- Timeline  -->
        <LayoutPane
          v-show  = "layout.timeline.visible"
          class   = "timeline"
          name    = "Timeline"
        >
        </LayoutPane>
      
      </div>

      <!-- Right Column -->
      <div 
        v-show  = "layout.topTabs.visible || layout.bottomTabs.visible"
        class   = "right column"
      >

        <!-- Top Tabs -->
        <TabsLayoutPane
          v-show  = "layout.topTabs.visible"
          class   = "top tabs"
          which   = "top"
          :layout = "layout"
        >
        </TabsLayoutPane>

        <!-- Bottom Tabs  -->
        <TabsLayoutPane
          v-show  = "layout.bottomTabs.visible"
          class   = "bottom tabs"
          which   = "bottom"
          :layout = "layout"
        >
        </TabsLayoutPane>

      </div>

    </div>

  </div>

</template>

<script>

// #region Imports

/* Telestream */
import FileToolbarLayoutPane from './FileToolbarLayoutPane.vue';
import LayoutPane from './LayoutPane.vue';
import TabsLayoutPane from './TabsLayoutPane.vue';

// #endregion Imports


export default {
  
  // #region Properties

  props: {
    layout: Object
  },
  components: {
    FileToolbarLayoutPane,
    LayoutPane,
    TabsLayoutPane
  }

  // #endregion Properties

}

</script>

<style scoped lang="scss">

.preview_container {
  width:          100%;
  display:        flex;
  flex-direction: column;
  gap:            8px;

  .header {
    height:         40px;
  }

  .main_content {
    height:         400px;
    display:        flex;
    flex-direction: row;
    gap:            8px;

    .left {
      flex:           4;
      display:        flex;
      flex-direction: column;
      gap:            8px;

      .video_player {
        flex:           4;
      }

      .timeline {
        flex:           1;
      }
    }

    .right {
      flex:           3;
      display:        flex;
      flex-direction: column;
      gap:            8px;

      .tabs {
        flex:           1;
      }
    }
  }
}

</style>